import React, { useState, useEffect } from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
import ProductosMain from '../../components/Admin/ProductosMain/ProductosMain'
import UsuariosMain from '../../components/Admin/UsuariosMain/UsuariosMain'
import CardsCantidad from '../../components/Admin/CardsCantidad/CardsCantidad'
import InfoUserMain from '../../components/Admin/InfoUserMain/InfoUserMain'
import baseURL from '../../components/url';

export default function Main({ logo }) {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${baseURL}/userLogued.php`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setUsuario(data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al obtener datos:', error);
                setLoading(false);
            });
    }, []);

    return (
        <div className='containerGrid'>
            <Header logo={logo} />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    {usuario.rol === 'admin' ? (
                        // Contenido completo para administradores
                        <>
                            <div className='deFLexMain'>
                                <CardsCantidad />
                                <UsuariosMain />
                            </div>
                            <div className='deFLexMain'>
                                <ProductosMain />
                                <InfoUserMain />
                            </div>
                        </>
                    ) : (
                        // Contenido limitado para usuarios
                        <>
                            <div className='deFLexMain'>
                                <CardsCantidad />
                                <InfoUserMain />
                            </div>
                            <div className='deFLexMain'>
                                <div style={{ 
                                    gridColumn: '1 / -1', 
                                    textAlign: 'center', 
                                    padding: '2rem',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '10px',
                                    border: '2px dashed #dee2e6'
                                }}>
                                    <h3>Bienvenido al Dashboard</h3>
                                    <p>Como usuario, puedes acceder a la sección de <strong>Pedidos</strong> para ver el historial de tus compras.</p>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </section>
        </div>
    )
}
